import React, { useContext, useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import Row from "react-bootstrap/Row";
import { Card, Col } from "react-bootstrap";
import {check, updateUserDataFront} from "../../http/userAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import response from "babel-loader/lib/Error";
import { findReviewerPenNameConflict, ReviewerNameSafetyModal } from "../../helpers/ReviewerNameSafety";
import ReviewerProfilesPanel from "./ReviewerProfilesPanel";

const UserProfile = observer(() => {
    const { user } = useContext(Context);
    const { book } = useContext(Context);

    const [canReviewAudible, setCanReviewAudible] = useState(() => !!user.user.audible_name);
    const [canReviewPaperBook, setCanReviewPaperBook] = useState(() => !!user.user.sex);

    const [showConfirmSave, setShowConfirmSave] = useState(false);
    const [inputValueSave, setInputValueSave] = useState("");
    const [reviewerSafetyConflict, setReviewerSafetyConflict] = useState(null);

    const confirmSave = () => {
        if (inputValueSave.trim().toUpperCase() === "SAVE") {
            const conflict = findReviewerPenNameConflict(formData.amz_name, book?.currentuserbooks || []);
            if (conflict) {
                setReviewerSafetyConflict(conflict);
                setShowConfirmSave(false);
                setInputValueSave("");
                return;
            }
            handleActualSave();
            setShowConfirmSave(false);
            setInputValueSave("");
        } else {
            toast.error("Please type 'SAVE' to confirm profile update.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    const amazonSites = [
        { code: "US", url: "https://www.amazon.com", label: "Amazon USA" },
        { code: "UK", url: "https://www.amazon.co.uk", label: "Amazon UK" },
        { code: "CA", url: "https://www.amazon.ca", label: "Amazon Canada" },
        { code: "DE", url: "https://www.amazon.de", label: "Amazon Germany" },
        { code: "FR", url: "https://www.amazon.fr", label: "Amazon France" },
        { code: "IT", url: "https://www.amazon.it", label: "Amazon Italy" },
        { code: "ES", url: "https://www.amazon.es", label: "Amazon Spain" },
        { code: "JP", url: "https://www.amazon.co.jp", label: "Amazon Japan" },
        { code: "AU", url: "https://www.amazon.com.au", label: "Amazon Australia" },
        { code: "IN", url: "https://www.amazon.in", label: "Amazon India" },
        { code: "MX", url: "https://www.amazon.com.mx", label: "Amazon Mexico" },
        { code: "BR", url: "https://www.amazon.com.br", label: "Amazon Brazil" },
    ];

    const audibleSites = [
        { code: "AUS", url: "https://www.audible.com", label: "Audible USA" },
        { code: "AUK", url: "https://www.audible.co.uk", label: "Audible UK" },
    ];

    // Пол
    const sexOptions = [
        { value: "", label: "Select your sex" },
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" },
    ];

// Уровень дохода
    const incomeOptions = [
        { value: "", label: "Select income level" },
        { value: "under_1000", label: "Less than $1,000" },
        { value: "1000_3000", label: "$1,001 – $3,000" },
        { value: "3001_5000", label: "$3,001 – $5,000" },
        { value: "5001_8000", label: "$5,001 – $8,000" },
        { value: "8001_12000", label: "$8,001 – $12,000" },
        { value: "12001_20000", label: "$12,001 – $20,000" },
        { value: "20001_30000", label: "$20,001 – $30,000" },
        { value: "30001_50000", label: "$30,001 – $50,000" },
        { value: "50001_plus", label: "More than $50,000" },
    ];
// Occupation options
    const occupationOptions = [
        { value: "", label: "Select occupation" },
        { value: "student", label: "Student" },
        { value: "unemployed", label: "Unemployed" },
        { value: "self_employed", label: "Self-Employed / Freelancer" },
        { value: "business_owner", label: "Business Owner / Entrepreneur" },
        { value: "manager", label: "Manager / Executive" },
        { value: "office_worker", label: "Office / Administrative Staff" },
        { value: "it", label: "IT / Software Developer" },
        { value: "engineer", label: "Engineer / Technical Specialist" },
        { value: "healthcare", label: "Healthcare Professional (Doctor, Nurse, etc.)" },
        { value: "teacher", label: "Teacher / Educator" },
        { value: "scientist", label: "Scientist / Researcher" },
        { value: "lawyer", label: "Lawyer / Legal Professional" },
        { value: "finance", label: "Finance / Banking / Accountant" },
        { value: "arts", label: "Artist / Designer / Creative" },
        { value: "writer", label: "Writer / Journalist" },
        { value: "sales", label: "Sales / Marketing" },
        { value: "service", label: "Service Industry (Retail, Hospitality)" },
        { value: "manual", label: "Skilled Trades (Construction, Mechanic, etc.)" },
        { value: "government", label: "Government / Public Service" },
        { value: "military", label: "Military / Security" },
        { value: "agriculture", label: "Agriculture / Farming" },
        { value: "transport", label: "Transport / Logistics" },
        { value: "other", label: "Other" },
    ];

// Образование
    const educationOptions = [
        { value: "", label: "Select education level" },
        { value: "no_school", label: "No formal education" },
        { value: "primary", label: "Primary School" },
        { value: "middle_school", label: "Middle School" },
        { value: "high_school", label: "High School" },
        { value: "vocational", label: "Vocational/Technical" },
        { value: "associate", label: "Associate Degree" },
        { value: "bachelor", label: "Bachelor's Degree" },
        { value: "master", label: "Master's Degree" },
        { value: "professional", label: "Professional Degree (MD, JD)" },
        { value: "phd", label: "PhD / Doctorate" },
        { value: "postdoc", label: "Postdoctoral / Advanced Research" },
    ];


// Любимые жанры Fiction
    const fictionGenres = [
        "Fantasy", "Science Fiction", "Romance", "Mystery/Thriller", "Historical Fiction", "Horror", "Young Adult"
    ];

// Любимые жанры Non-Fiction
    const nonfictionGenres = [
        "Biography", "Self-Help", "Business", "Health & Wellness", "History", "Science & Technology", "Travel"
    ];


    const [formData, setFormData] = useState({
        id: '',
        email: '',
        username: '',
        amz_name: '',
        audible_name: '',
        amz_country: '',
        audible_country: '',
        // 👇 для печатных книг
        sex: '',
        age: '',
        income: '',
        education: '',
        fiction_genres: [],
        nonfiction_genres: [],
        occupation: '',
    });


    const [isAmazonLocked, setIsAmazonLocked] = useState(false);
    const [isAudibleLocked, setIsAudibleLocked] = useState(false);


    useEffect(() => {
        // Заполняем начальные данные из store пользователя
        setFormData({
            id: user.user.id || '',
            email: user.user.email || '',
            username: user.user.username || '',
            amz_name: user.user.amz_name || '',
            audible_name: user.user.audible_name || '',
            amz_country: user.user.amz_country || '',
            audible_country: user.user.audible_country || '',
            // 👇 новые поля
            sex: user.user.sex || '',
            age: user.user.age ?? '',
            income: user.user.income || '',
            education: user.user.education || '',
            fiction_genres: Array.isArray(user.user.fiction_genres) ? user.user.fiction_genres : [],
            nonfiction_genres: Array.isArray(user.user.nonfiction_genres) ? user.user.nonfiction_genres : [],
            occupation: user.user.occupation || '',
        });

        const getAllowedNameChanges = (plan) => {
            const p = String(plan || "").toLowerCase();
            if (p.includes("free")) return 1;
            if (p.includes("essential")) return 1;
            if (p.includes("premium") || p.includes("maximum")) return 1;
            return 1; // fallback
        };

        const allowed = getAllowedNameChanges(user?.user?.tariff_plan);

        const amazonUsed  = Number(user?.user?.amazon_rn_changes ?? 0);
        const audibleUsed = Number(user?.user?.audible_rn_changes ?? 0);

        const amazonRemaining  = Math.max(0, allowed - amazonUsed);
        const audibleRemaining = Math.max(0, allowed - audibleUsed);

        setIsAmazonLocked(amazonRemaining <= 0);
        setIsAudibleLocked(audibleRemaining <= 0);

    }, [user.user]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // ✅ Обновленный обработчик изменения селекта
    const handleSiteChange = (e) => {
        const newSite = e.target.value;
        setFormData(prev => ({
            ...prev,
            amz_country: newSite  // ✅ Теперь `amz_country` обновляется при выборе
        }));
    };
    const handleASiteChange = (e) => {
        const newSite = e.target.value;
        setFormData(prev => ({
            ...prev,
            audible_country: newSite  // ✅ Теперь `amz_country` обновляется при выборе
        }));
    };

    const handleCheckboxChange = (e, field, value) => {
        const checked = e.target.checked;

        setFormData(prev => {
            const prevArr = Array.isArray(prev[field]) ? prev[field] : [];
            const nextArr = checked
                ? Array.from(new Set([...prevArr, value])) // добавить без дублей
                : prevArr.filter(v => v !== value);        // удалить

            return { ...prev, [field]: nextArr };
        });
    };

       const handleActualSave = async (e) => {
           if (e?.preventDefault) e.preventDefault();

        // Проверяем, что все поля заполнены (без пробелов)
        if (!formData.username.trim() || !formData.email.trim()) {
            toast.error("Please fill in all fields.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        const editDate = Date.now();

           try {
               const resp = await updateUserDataFront(
                   formData.id,
                   formData.email,
                   null,                 // пароль не меняем здесь
                   formData.username,
                   formData.amz_name,
                   formData.audible_name,
                   editDate,
                   formData.amz_country,
                   formData.audible_country,
                   // 👇 добавляем новые поля
                   formData.sex,
                   formData.age,
                   formData.income,
                   formData.education,
                   formData.fiction_genres,
                   formData.nonfiction_genres,
                   formData.occupation,
               );


               // resp: { token?, message? }
               if (resp?.token) {
                   // Были изменения → подтянуть свежие данные пользователя
                   const data = await check();
                   user.setUser(data);
                   toast.success(resp.message || "Profile updated successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
               } else {
                   // Не было изменений → показать серверное сообщение (или fallback)
                   toast.info(resp?.message || "No changes were made, the user data is the same.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
               }
           } catch (error) {
               console.error("Error updating user data:", error);
               const errorMsg =
                   (error.response && error.response.data && error.response.data.message) ||
                   "Failed to update profile. Please try again.";
               toast.error(errorMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
           }
    };

    return (
        <>
        <ReviewerNameSafetyModal
            show={!!reviewerSafetyConflict}
            conflict={reviewerSafetyConflict}
            onCancel={() => setReviewerSafetyConflict(null)}
            onContinue={() => {
                setReviewerSafetyConflict(null);
                handleActualSave();
            }}
        />
        <Card className="border-0">
            <Row>

                <Col>
                    <Card className="shadow-sm p-0 bg-white rounded">
                        <Card.Body>
                            <h6 className="fs-5 text-muted mb-3">
                                Update your account details and reviewer profile sets.
                            </h6>
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                setShowConfirmSave(true);
                            }}>
                                {/* Первая строка: Имя пользователя, Email и сохранение */}
                                <Row className="mb-3 align-items-end">
                                    <Col xs={12} lg={5} className="mb-3 mb-lg-0">
                                        <div className="text-muted small mb-1">
                                            Update the Username you use on our platform.
                                        </div>
                                        <input
                                            name="username"
                                            value={formData.username}
                                            onChange={handleInputChange}
                                            type="text"
                                            className="form-control form-control-sm border-secondary"
                                            id="username"
                                            placeholder="Enter your name"
                                        />
                                    </Col>

                                    <Col xs={12} lg={5} className="mb-3 mb-lg-0">
                                        <div className="text-muted small mb-1">
                                            Update your E-Mail for notifications and updates.
                                        </div>
                                        <input
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            type="email"
                                            className="form-control form-control-sm border-secondary"
                                            id="email"
                                            placeholder="Enter your email"
                                        />
                                    </Col>

                                    <Col xs={12} lg={2} className="position-relative">
                                        <button type="submit" className="btn btn-success btn-sm text-white w-100">
                                            Save Changes
                                        </button>

                                        {showConfirmSave && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "calc(100% + 8px)",
                                                    right: "0",
                                                    background: "white",
                                                    border: "1px solid gray",
                                                    padding: "10px",
                                                    borderRadius: "8px",
                                                    zIndex: 100,
                                                    boxShadow: "0px 2px 8px rgba(0,0,0,0.2)",
                                                    width: "260px"
                                                }}
                                            >
                                                <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                                                    Please confirm that you want to update your profile details.<br />
                                                    <strong>Type SAVE to confirm.</strong>
                                                </p>

                                                <input
                                                    type="text"
                                                    value={inputValueSave}
                                                    onChange={(e) => setInputValueSave(e.target.value)}
                                                    placeholder="Type SAVE"
                                                    className="form-control mb-2"
                                                />
                                                <div className="d-flex justify-content-between">
                                                    <button type="button" onClick={confirmSave} className="btn btn-success btn-sm flex-grow-1 me-1">
                                                        Confirm Save
                                                    </button>
                                                    <button type="button" onClick={() => setShowConfirmSave(false)} className="btn btn-outline-success btn-sm flex-grow-1 ms-1">
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                <ReviewerProfilesPanel tariffPlan={user?.user?.tariff_plan} />

                                <div className="d-none">
                                <Row className="mb-3">
                                    <Col xs={12}>
                                        {(() => {
                                            const plan = String(user?.user?.tariff_plan || "").toLowerCase();
                                            const getAllowedNameChanges = (p) => {
                                                if (p.includes("free")) return 1;
                                                if (p.includes("essential")) return 1;
                                                if (p.includes("premium") || p.includes("maximum")) return 1;
                                                return 1; // fallback — как было раньше
                                            };

                                            const allowed = getAllowedNameChanges(plan);
                                            const amazonUsed  = Number(user?.user?.amazon_rn_changes ?? 0);
                                            const audibleUsed = Number(user?.user?.audible_rn_changes ?? 0);

                                            const remainingAmazon  = Math.max(0, allowed - amazonUsed);
                                            const remainingAudible = Math.max(0, allowed - audibleUsed);

                                            const planLabel = user?.user?.tariff_plan || "your plan";

                                            return (
                                                <>
                                                    <h5 className="text-danger">
                                                        Important: Reviewer Name replacement are limited. <br className="d-md-none" />
                                                        Remaining — Amazon: {remainingAmazon} / {allowed}, Audible: {remainingAudible} / {allowed}.
                                                    </h5>
                                                    <p className="text-muted fst-italic mb-0">
                                                        <strong>Attention!</strong> Under <strong>{planLabel}</strong>, you can change your
                                                        <strong> Amazon Reviewer Name / Country Site</strong> and <strong>Audible Reviewer Name / Country Site</strong> up to{" "}
                                                        <strong>{allowed} {allowed === 1 ? "time" : "times"}</strong>.
                                                        This limit helps prevent misuse and protects other users. Please enter your reviewer names
                                                        thoughtfully to avoid mistakes. Further changes beyond this limit are only possible by contacting support. <strong>Don’t worry: your first reviewer name set isn’t a replacement—only replacements are limited.</strong>
                                                    </p>
                                                </>
                                            );
                                        })()}
                                    </Col>

                                </Row>


                                {/* Вторая строка: Amazon Reviewer Name и Страна Amazon */}
                                <Row className="mb-4">
                                    <Col xs={12} md={6} className="mb-3 mb-md-0">
                                        <label
                                            htmlFor="amz_name"
                                            className="form-label d-flex justify-content-between align-items-center"
                                        >
                                            <strong>Amazon Reviewer Name:</strong>

                                            {(() => {
                                                const plan = String(user?.user?.tariff_plan || "").toLowerCase();
                                                const allowed =
                                                    plan.includes("free") ? 1 :
                                                        plan.includes("essential") ? 1 :
                                                            (plan.includes("premium") || plan.includes("maximum")) ? 1 : 1;

                                                const used = Number(user?.user?.amazon_rn_changes ?? 0);
                                                const remaining = Math.max(0, allowed - used);

                                                return (
                                                    <span className={`small ${remaining <= 0 ? "text-danger" : "text-muted"}`}>
        {remaining <= 0
            ? "Contact support to change"
            : `${remaining} attempt${remaining === 1 ? "" : "s"} left`}
      </span>
                                                );
                                            })()}
                                        </label>


                                        <div style={{ marginBottom: "5px", fontSize: "small" }} className="mt-0 p-0">
                                            Update the name linked to your Amazon reviews.
                                            This is used to verify your review authorship and mark tasks as completed.
                                        </div>
                                        <input
                                            name="amz_name"
                                            value={formData.amz_name}
                                            onChange={handleInputChange}
                                            onBlur={(e) =>
                                                setFormData((prevData) => ({
                                                    ...prevData,
                                                    [e.target.name]: e.target.value.trim(),
                                                }))
                                            }
                                            type="text"
                                            className="form-control form-control-sm border-secondary"
                                            id="amz_name"
                                            placeholder="Enter your Amazon name"
                                            disabled={isAmazonLocked}
                                        />
                                        {isAmazonLocked && (
                                            <div className="text-danger" style={{ fontSize: "small", marginTop: "5px" }}>
                                                You have used all attempts to edit this field.
                                                For changes, contact support.
                                            </div>
                                        )}
                                    </Col>

                                    <Col xs={12} md={6}>
                                        <label htmlFor="amz_country" className="form-label">
                                            <strong>Amazon Reviewer Country Site:</strong>
                                        </label>
                                        <div style={{ marginBottom: "5px", fontSize: "small" }} className="mt-0 p-0">
                                            Update the country linked to your Amazon Reviewer Name.
                                            This is used to boost customer experience.
                                        </div>
                                        <select
                                            id="amazonSites"
                                            name="amz_country"
                                            value={formData.amz_country}
                                            className="form-select form-select-sm border-secondary"
                                            onChange={handleSiteChange}
                                            disabled={isAmazonLocked}
                                        >
                                            <option value="" disabled>
                                                Select Amazon Marketplace
                                            </option>
                                            {amazonSites.map((site) => (
                                                <option key={site.code} value={site.url}>
                                                    {site.label}
                                                </option>
                                            ))}
                                        </select>
                                        {isAmazonLocked && (
                                            <div className="text-danger" style={{ fontSize: "small", marginTop: "5px" }}>
                                                You have used all attempts to edit this field.
                                                For changes, contact support.
                                            </div>
                                        )}
                                    </Col>
                                </Row>


                                <div className="form-check form-switch mb-0 align-items-center">
                                    <input
                                        className={`form-check-input ${canReviewAudible ? 'bg-success border-success' : 'bg-light border-secondary'}`}
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchCheckAudible"
                                        checked={canReviewAudible}
                                        onChange={() => setCanReviewAudible((prev) => !prev)}
                                    />
                                    <div className="w-100">
                                        <label
                                            className="form-check-label mt-0 ms-2 text-start text-wrap"
                                            htmlFor="flexSwitchCheckAudible"
                                            style={{ wordBreak: 'break-word' }}
                                        >
                                            <h6 className="text-muted">
                                                {canReviewAudible
                                                    ? 'Great! You confirm that you can post a review on Audible.'
                                                    : 'Can You Listen and Post a Review on Audible.com or Audible.co.uk?'}
                                            </h6>
                                        </label>
                                    </div>
                                </div>
                                <div className="p-3 mt-2 mb-3 border border-secondary rounded">
                                <div className="w-100 mb-2">
                                        {canReviewAudible ? (
                                            <p className="text-muted fst-italic  mt-1 mb-0">
                                                By enabling this option, you take responsibility for listening to the assigned audiobook in full
                                                and posting a genuine, honest review on <strong>Audible.com</strong> or <strong>Audible.co.uk</strong>.
                                                This commitment is part of the trust system between authors and reviewers.
                                                Please make sure you understand these obligations before proceeding.
                                            </p>
                                        ) : (
                                            <p className="text-muted fst-italic  mt-1 mb-0">
                                                If you enable this option, you’ll be required to provide your Audible reviewer name and confirm
                                                that you are genuinely able to publish reviews on the Audible marketplace.
                                                This helps ensure fair collaboration and prevents misuse.
                                            </p>
                                        )}
                                    </div>

                                {canReviewAudible && (
                                    <>
                                {/* Третья строка: Audible Reviewer Name и Страна Audible */}
                                        <Row className="mb-3 g-3">
                                            <Col xs={12} md={6}>
                                                <label
                                                    htmlFor="audible_name"
                                                    className="form-label d-flex justify-content-between align-items-center"
                                                >
                                                    <strong>Audible Reviewer Name:</strong>
                                                    {(() => {
                                                        const plan = String(user?.user?.tariff_plan || "").toLowerCase();
                                                        const allowed =
                                                            plan.includes("free") ? 1 :
                                                                plan.includes("essential") ? 1 :
                                                                    (plan.includes("premium") || plan.includes("maximum")) ? 1 : 1;

                                                        const used = Number(user?.user?.audible_rn_changes ?? 0);
                                                        const remaining = Math.max(0, allowed - used);

                                                        return (
                                                            <span className={`small ${remaining <= 0 ? "text-danger" : "text-muted"}`}>
        {remaining <= 0
            ? "Contact support to change"
            : `${remaining} attempt${remaining === 1 ? "" : "s"} left`}
      </span>
                                                        );
                                                    })()}
                                                </label>



                                                <div style={{ marginBottom: "5px", fontSize: "small" }} className="mt-0 p-0">
                                                    Update the name linked to your Audible reviews.
                                                    This is used to verify your review authorship and mark tasks as completed.
                                                </div>
                                                <input
                                                    name="audible_name"
                                                    value={formData.audible_name}
                                                    onChange={handleInputChange}
                                                    type="text"
                                                    className="form-control form-control-sm border-secondary"
                                                    id="audible_name"
                                                    placeholder="Enter your Audible name"
                                                    disabled={isAudibleLocked}
                                                />
                                                {isAudibleLocked && (
                                                    <div className="text-danger" style={{ fontSize: "small", marginTop: "5px" }}>
                                                        You have used all attempts to edit this field.
                                                        For changes, contact support.
                                                    </div>
                                                )}
                                            </Col>

                                            <Col xs={12} md={6}>
                                                <label htmlFor="audible_country" className="form-label">
                                                    <strong>Audible Reviewer Country Site:</strong>
                                                </label>
                                                <div style={{ marginBottom: "5px", fontSize: "small" }} className="mt-0 p-0">
                                                    Update the country linked to your Audible Reviewer Name.
                                                    This is used to boost customer experience.
                                                </div>
                                                <select
                                                    id="audibleSites"
                                                    name="audible_country"
                                                    value={formData.audible_country}
                                                    className="form-select form-select-sm border-secondary"
                                                    onChange={handleASiteChange}
                                                    disabled={isAudibleLocked}
                                                >
                                                    <option value="" disabled>Select Audible Marketplace</option>
                                                    {audibleSites.map((asite) => (
                                                        <option key={asite.code} value={asite.url}>
                                                            {asite.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {isAudibleLocked && (
                                                    <div className="text-danger" style={{ fontSize: "small", marginTop: "5px" }}>
                                                        You have used all attempts to edit this field.
                                                        For changes, contact support.
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>

                                    </>
                               )}
</div>
                                </div>
                                {/* Чекер для Paperback & Hardcover */}
                                <div className="d-none">
                                <div className="form-check form-switch mb-0 mt-4 align-items-center">
                                    <input
                                        className={`form-check-input ${canReviewPaperBook ? 'bg-success border-success' : 'bg-light border-secondary'}`}
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchCheckPaperBook"
                                        checked={canReviewPaperBook}
                                        onChange={() => setCanReviewPaperBook((prev) => !prev)}
                                    />
                                    <div className="w-100">
                                        <label
                                            className="form-check-label mt-0 ms-2 text-start text-wrap"
                                            htmlFor="flexSwitchCheckPaperBook"
                                            style={{ wordBreak: 'break-word' }}
                                        >
                                            <h6 className="text-muted">
                                                {canReviewPaperBook
                                                    ? 'Great! You confirm that you can buy, receive, and review paperback & hardcover books.'
                                                    : 'Can you purchase and post reviews for paperback and hardcover books?'}
                                            </h6>
                                        </label>
                                    </div>
                                </div>
                                <div className="p-3 mt-2 mb-3 border border-secondary rounded">
                                <div className="w-100 mb-2">
                                    {canReviewPaperBook ? (
                                        <p className="text-muted fst-italic mt-1 mb-0">
                                            By enabling this option, you confirm that you are willing and able to <strong>purchase</strong> physical books (paperbacks or hardcovers), <strong>receive them by Delivery Service</strong>, and <strong>post authentic reviews</strong> that may include <u>photos or video materials</u>.
                                            This information is required to assign you tasks that involve real book purchases.
                                        </p>
                                    ) : (
                                        <p className="text-muted fst-italic mt-1 mb-0">
                                            Some assignments may require buying a physical book and posting a review with proof.
                                            If you enable this option, please fill in the additional fields below to help match you
                                            with appropriate requests.
                                        </p>
                                    )}
                                </div>

                                {canReviewPaperBook && (
                                    <>
                                        <Row className="g-2 mb-3">
                                            <Col xs={12} sm={6} md={2} className="mb-2 mb-md-0">
                                                <label htmlFor="sex" className="form-label mb-1 "><strong>Sex</strong></label>
                                                <select
                                                    id="sex"
                                                    name="sex"
                                                    value={formData.sex}
                                                    className="form-select form-select-sm border-secondary"
                                                    onChange={handleInputChange}
                                                    aria-label="Select sex"
                                                >
                                                    <option value="">Select</option>
                                                    {sexOptions.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </Col>

                                            <Col xs={12} sm={6} md={2} className="mb-2 mb-md-0">
                                                <label htmlFor="age" className="form-label mb-1 "><strong>Age</strong></label>
                                                <select
                                                    id="age"
                                                    name="age"
                                                    value={formData.age || ""}
                                                    className="form-select form-select-sm border-secondary"
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select age</option>
                                                    {Array.from({ length: 82 }, (_, i) => 18 + i).map((num) => (
                                                        <option key={num} value={num}>{num}</option>
                                                    ))}
                                                </select>
                                            </Col>

                                            <Col xs={12} sm={6} md={2} className="mb-2 mb-md-0">
                                                <label htmlFor="income" className="form-label mb-1 "><strong>Income</strong></label>
                                                <select
                                                    id="income"
                                                    name="income"
                                                    value={formData.income}
                                                    className="form-select form-select-sm border-secondary"
                                                    onChange={handleInputChange}
                                                    aria-label="Select income"
                                                >
                                                    <option value="">Select</option>
                                                    {incomeOptions.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </Col>

                                            <Col xs={12} sm={6} md={3} className="mb-2 mb-md-0">
                                                <label htmlFor="education" className="form-label mb-1 "><strong>Education</strong></label>
                                                <select
                                                    id="education"
                                                    name="education"
                                                    value={formData.education}
                                                    className="form-select form-select-sm border-secondary"
                                                    onChange={handleInputChange}
                                                    aria-label="Select education"
                                                >
                                                    <option value="">Select</option>
                                                    {educationOptions.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </Col>

                                            <Col xs={12} md={3}>
                                                <label htmlFor="occupation" className="form-label mb-1 "><strong>Occupation</strong></label>
                                                <select
                                                    name="occupation"
                                                    value={formData.occupation}
                                                    onChange={handleInputChange}
                                                    className="form-select form-select-sm border-secondary"
                                                    id="occupation"
                                                    aria-label="Select occupation"
                                                >
                                                    <option value="">Select</option>
                                                    {occupationOptions.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </Col>
                                        </Row>




                                        <Row className="mb-3 g-3">
                                            <Col xs={12} sm={6} md={6}>
                                                <label className="form-label"><strong>Favorite Fiction Genres:</strong></label>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {fictionGenres.map((genre) => (
                                                        <div key={genre} className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`fiction_${genre}`}
                                                                checked={formData.fiction_genres?.includes(genre) || false}
                                                                onChange={(e) => handleCheckboxChange(e, "fiction_genres", genre)}
                                                            />
                                                            <label className="form-check-label small" htmlFor={`fiction_${genre}`}>
                                                                {genre}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>

                                            <Col xs={12} sm={6} md={6}>
                                                <label className="form-label"><strong>Favorite Non-Fiction Genres:</strong></label>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {nonfictionGenres.map((genre) => (
                                                        <div key={genre} className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`nonfiction_${genre}`}
                                                                checked={formData.nonfiction_genres?.includes(genre) || false}
                                                                onChange={(e) => handleCheckboxChange(e, "nonfiction_genres", genre)}
                                                            />
                                                            <label className="form-check-label small" htmlFor={`nonfiction_${genre}`}>
                                                                {genre}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>



                                    </>
                                )}
                                </div>
                                </div>

                            </form>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
        </Card>
        </>
    );
});

export default UserProfile;
